import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Form, Select, Table } from 'tdesign-react';
import { isEmpty, renderByte, toTsOptions } from '@/utils/common';
import useTable from '@/hooks/useTable';
import LedgerModal from './LedgerModal';

const { FormItem } = Form;

export const renderBoolean = ({ row, col }) => {
  const item = row[col.colKey];
  if (isEmpty(item)) {
    return '-';
  }
  return item === true ? '是' : '否';
};

function Ledgers({ segmentsList, commonProps }) {
  const columns = [
    {
      title: 'Ledger ID',
      colKey: 'ledgerId',
      cell: ({ row }) => <LedgerModal commonProps={commonProps} detail={row} />,
    },
    {
      title: '数据个数',
      colKey: 'entries',
    },
    {
      title: '数据大小',
      colKey: 'size',
      cell: renderByte,
    },
    {
      title: '副本缺失',
      colKey: 'underReplicated',
      cell: renderBoolean,
    },
    {
      title: 'Offload',
      colKey: 'offLoad',
      cell: renderBoolean,
    },
  ];

  const { header, config, setData, form } = useTable({
    columns,
    refresh: null,
    columnController: null,
    searchButton: null,
    search: (
      <FormItem name='ledgerId'>
        <Select
          clearable
          filterable
          placeholder='请输入ledger id'
          options={toTsOptions(
            segmentsList.map((item) => ({
              label: String(item.ledgerId),
              value: item.ledgerId,
            })),
          )}
        />
      </FormItem>
    ),
  });

  const ledgerId = Form.useWatch('ledgerId', form);

  useEffect(() => {
    if (ledgerId) {
      setData(segmentsList.filter((item) => item.ledgerId === ledgerId));
    } else {
      setData(segmentsList);
    }
  }, [segmentsList, setData, ledgerId]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

export default connect((state) => ({
  segmentsList: state.topic.storage.segmentsList || [],
}))(Ledgers);

const Root = styled.div`
  padding-top: 8px;
`;
